module.exports = __webpack_public_path__ + "img/93.998f2256.png";